import React, { FC } from 'react'
import { Alert } from '@wmgtech/legato'

import './ArchivedAlert.scss'

const ArchivedAlert: FC = () => (
  <Alert
    className="archived-alert"
    title=""
    colorType="warning"
    dissmisable={false}
    icon="triangle-exclamation"
    text="This Project is currently archived. To edit a project it must be active."
  />
)

export default ArchivedAlert
